import { Component, OnDestroy, OnInit } from '@angular/core';
import {Direction} from "@angular/cdk/bidi";
import {ConfigService} from "../services/config.service";
import {DirectionService} from "../services/direction.service";
import {InConfiguration} from "../models/config.interface";
import {AuthService} from "../auth.service";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  direction!: Direction;
  public config!: InConfiguration;
  constructor(
    private directoryService: DirectionService,
    private configService: ConfigService,
    private authService: AuthService
  ) {
//     const uid = "BIYwLTw9wCNj1O5HjDRGjl3Jgpl1"
//     const password ="AL@123456"
// this.authService.changePasswordOfAnotherUser(uid, password).then(res=>{
//   alert("Password changed successfully")
// })carrs


    this.config = this.configService.configData;
    this.directoryService.currentData.pipe(takeUntil(this._destroyed$)).subscribe((currentData) => {
      if (currentData) {
        this.direction = currentData === 'ltr' ? 'ltr' : 'rtl';
      } else {
        if (localStorage.getItem('isRtl')) {
          if (localStorage.getItem('isRtl') === 'true') {
            this.direction = 'rtl';
          } else if (localStorage.getItem('isRtl') === 'false') {
            this.direction = 'ltr';
          }
        } else {
          if (this.config) {
            if (this.config.layout.rtl === true) {
              this.direction = 'rtl';
              localStorage.setItem('isRtl', 'true');
            } else {
              this.direction = 'ltr';
              localStorage.setItem('isRtl', 'false');
            }
          }
        }
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}
